var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "w-full h-full flex justify-center items-center" },
    [
      _c("div", {
        class: [`size-${_vm.size}`, "grm-loading-circle border-4 rounded-full"],
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }